export enum CompanyState {
  SUSPENDED = '0',
  ACTIVE = '1',
}
